import React, { lazy, Suspense, useEffect, useState } from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { Layout } from "antd";
import SidebarMenu from "../../components/sideBarMenu/SidebarMenu";
import AppHeader from "../../components/appHeader/AppHeader";
import PageNotFound from "../../pages/PageNotFound";
import WithAuth from "../WithAuth";
import DemoDash from "../../pages/DemoDash";
// import InstructorDashboard from "../../pages/instructorDashboard/InstructorDashboard";
// import Home from "../../pages/home/Home";
// import Body from "../../components/body/Body";
// import MyCourses from "../../pages/myCourses/MyCourses";
// import User from "../../pages/user/User";
// import WishList from "../../pages/wishlist/WishList";
// import Courses from "../../pages/courses/Courses";
// import CourseInfo from "../../pages/courseInfo/CourseInfo";
// import ReadCourse from "../../pages/courseInfo/ReadCourse";
// import SearchPage from "../../pages/searchPage/SearchPage";
// import UserProfile from "../../pages/userProfile/UserProfile";
// import Account from "../../pages/account/Account";
// import EducatorProfile from "../../pages/educatorProfile/EducatorProfile";
// import Messages from "../../pages/messages/Messages";
// import Blog from "../../pages/blog/Blog";
// import Contact from "../../pages/contact/Contact";
// import About from "../../pages/about/About";
// import Privacy from "../../pages/privacy/Privacy";
// import TermsAndConditions from "../../pages/terms_and_coditions/TermsAndConditions";
// import Faq from "../../pages/faq/Faq";
// import RefundPolicy from "../../pages/refundPolicy/RefundPolicy";
// import EditCourse from "../../pages/Instructor/AddCourse/EditCourse";
import {
  AddCourse,
  CourseManager,
  InstructorHome,
  InstructurDashboard,
  InstructurSidebar,
  PayoutReport,
  PayoutSettings,
  SalesReport,
  ZoomLiveSetting,
} from "../../pages/Instructor";
import InstructorQuizResult from "../../pages/InstructorQuizResult/InstructorQuizResult";
import Signup from "../../pages/signup/Signup";
import ChangePassword from "../../pages/changePassword/ChangePassword";

const Home = lazy(() => import("../../pages/home/Home"));
const Body = lazy(() => import("../../components/body/Body"));
const MyCourses = lazy(() => import("../../pages/myCourses/MyCourses"));
const User = lazy(() => import("../../pages/user/User"));
const WishList = lazy(() => import("../../pages/wishlist/WishList"));
const Courses = lazy(() => import("../../pages/courses/Courses"));
const CourseInfo = lazy(() => import("../../pages/courseInfo/CourseInfo"));
const ReadCourse = lazy(() => import("../../pages/courseInfo/ReadCourse"));
const SearchPage = lazy(() => import("../../pages/searchPage/SearchPage"));
const UserProfile = lazy(() => import("../../pages/userProfile/UserProfile"));
const Account = lazy(() => import("../../pages/account/Account"));
const EducatorProfile = lazy(() =>
  import("../../pages/educatorProfile/EducatorProfile")
);
const Messages = lazy(() => import("../../pages/messages/Messages"));
const Blog = lazy(() => import("../../pages/blog/Blog"));
const Contact = lazy(() => import("../../pages/contact/Contact"));
const About = lazy(() => import("../../pages/about/About"));
const Privacy = lazy(() => import("../../pages/privacy/Privacy"));
const TermsAndConditions = lazy(() =>
  import("../../pages/terms_and_coditions/TermsAndConditions")
);
const Faq = lazy(() => import("../../pages/faq/Faq"));
const RefundPolicy = lazy(() => import("../../pages/refundPolicy/RefundPolicy"));
const EditCourse = lazy(() => import("../../pages/Instructor/AddCourse/EditCourse"));



const { Content } = Layout;

const PrivateRoutes = () => {
  const location = useLocation();
  const [collapsed, setCollapsed] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return (
    // <Layout style={{ minHeight: "100vh" }}>
    //   <Layout style={{ display: "flex" }}>
    //     {location.pathname === "/dashboard" && <SidebarMenu collapsed={collapsed} />}
    //     <Layout style={{ flex: 1 }}>
    //       {/* <AppHeader collapsed={collapsed} setCollapsed={setCollapsed} /> */}
    //       <Content
    //         // style={{
    //         //   padding: "0 50px",
    //         //   marginTop: 0,
    //         //   minHeight: 280,
    //         // }}
    //       >
    <Suspense fallback={<div>Loading...</div>}>
      <Routes>
        {/* <Route
                  path="/dashboard"
                  element={
                    <WithAuth>
                      <DemoDash />
                    </WithAuth>
                  }
                /> */}

        <Route
          path="/"
          element={
            <WithAuth>
              <Home />
            </WithAuth>
          }
        >
          <Route
            path="/"
            element={

                <Body />
         
            }
          />

          <Route
            path="/user"
            element={
              <WithAuth>
                <User />
              </WithAuth>
            }
          >
            <Route
              path="/user/my-courses"
              element={
                <WithAuth>
                  <MyCourses />
                </WithAuth>
              }
            />

            <Route
              path="/user/my-wishlist"
              element={
                <WithAuth>
                  <WishList />
                </WithAuth>
              }
            />

            <Route
              path="/user/user-profile"
              element={
                <WithAuth>
                  <UserProfile />
                </WithAuth>
              }
            />

            <Route
              path="/user/messages"
              element={
                <WithAuth>
                  <Messages />
                </WithAuth>
              }
            />

            <Route
              path="/user/account"
              element={
                <WithAuth>
                  <Account />
                </WithAuth>
              }
            />
          </Route>

          <Route
            path="/courses"
            element={
              <WithAuth>
                <Courses />
              </WithAuth>
            }
          />

          <Route
            path="/course/:id"
            element={
              <WithAuth>
                <CourseInfo />
              </WithAuth>
            }
          />

          <Route
            path="/reset-password"
            element={
              <WithAuth>
                <ChangePassword />
              </WithAuth>
            }
          />


          <Route
            path="/course/:id/read"
            element={
              <WithAuth>
                <ReadCourse />
              </WithAuth>
            }
          />

          {/* <Route
            path="/quizresults/course/:id/section/:sectionId/quiz/:quizId/student/:studentId"
            element={
              <WithAuth>
                <ReadCourse />
              </WithAuth>
            }
          /> */}

         <Route
            path="/signup"
            element={
              <WithAuth>
                <Signup />
              </WithAuth>
            }
          />

          <Route
            path="/search"
            element={
              <WithAuth>
                <SearchPage />
              </WithAuth>
            }
          />

          <Route
            path="/educator-profile/:id"
            element={
              <WithAuth>
                <EducatorProfile />
              </WithAuth>
            }
          />

          <Route
            path="/blog"
            element={
              <WithAuth>
                <Blog />
              </WithAuth>
            }
          />

          <Route
            path="/contact"
            element={
              <WithAuth>
                <Contact />
              </WithAuth>
            }
          />

          <Route
            path="/about"
            element={
              <WithAuth>
                <About />
              </WithAuth>
            }
          />

          <Route
            path="/privacy_policy"
            element={
              <WithAuth>
                <Privacy />
              </WithAuth>
            }
          />

          <Route
            path="/terms_and_conditions"
            element={
              <WithAuth>
                <TermsAndConditions />
              </WithAuth>
            }
          />

          <Route
            path="/faq"
            element={
              <WithAuth>
                <Faq />
              </WithAuth>
            }
          />

          <Route
            path="/refund_and_policy"
            element={
              <WithAuth>
                <RefundPolicy />
              </WithAuth>
            }
          />
        </Route>
        <Route path="/instructor" element={<InstructurSidebar />}>
          <Route
            path="/instructor/dashboard"
            element={<InstructurDashboard />}
          />
          <Route
            path="/instructor/course_manager"
            element={<CourseManager />}
          />
          <Route path="/instructor/edit-course/:id" element={<EditCourse />} />
          <Route path="/instructor/add_course" element={<AddCourse />} />
          <Route path="/instructor/sales_report" element={<SalesReport />} />
          <Route path="/instructor/payout_report" element={<PayoutReport />} />
          <Route
            path="/instructor/zoom_live_settings"
            element={<ZoomLiveSetting />}
          />
        </Route>

        <Route path="/home" element={<InstructorHome />}>
          <Route path="/home/payout_settings" element={<PayoutSettings />} />
        </Route>
        <Route path="*" element={<PageNotFound />} />
        <Route
            path="/quizresults/course/:id/section/:sectionId/quiz/:quizId/student/:studentId"
            element={
              <WithAuth>
                <InstructorQuizResult/>
              </WithAuth>
            }
          />
        {/* <Route path="*" element={<Navigate to="/" />} /> */}
      </Routes>
    </Suspense>
    //       </Content>
    //     </Layout>
    //   </Layout>
    // </Layout>
  );
};

export default PrivateRoutes;
